import { render, staticRenderFns } from "./ValidRatificaciones.vue?vue&type=template&id=4bb9a187"
import script from "./ValidRatificaciones.vue?vue&type=script&lang=js"
export * from "./ValidRatificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb9a187')) {
      api.createRecord('4bb9a187', component.options)
    } else {
      api.reload('4bb9a187', component.options)
    }
    module.hot.accept("./ValidRatificaciones.vue?vue&type=template&id=4bb9a187", function () {
      api.rerender('4bb9a187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/ValidRatificaciones.vue"
export default component.exports